module.exports = __webpack_public_path__ + "media/images/check_flat/default-6a1f4b18adc073d99ae6e4dc66cdac88.png";